import { createContext } from "react"

const Audio = createContext()

export default Audio
